export default "__VITE_ASSET__Bsa2iAk8__"